<template>
  <div class="container" style="height:750px">
          <h1>
          Políticas de Tratamiento de Datos Personales
          </h1> 
          En cumplimiento de la ley 1581 de 2012 y el decreto reglamentario 1377 de 2013, Empaques Lupa pone en conocimiento de sus clientes la política de tratamiento de datos personales con la cual se busca proteger los derechos legales y constitucionales de todos y cada uno de los titulares de la información.

          Responsable Del Tratamiento
          Empaques Lupa es la entidad responsable del tratamiento de la información suministrada por los clientes, el domicilio de la misma corresponde a la Carrera 31 #9C-70 Cali - Colombia, WhatsApp (57) 3183953381. El correo electrónico de contacto es: empaqueslupa@gmail.com 
          Alcance
          La política descrita en el presente documento será aplicable a los datos personales suministrados por los clientes en la página web www.empaqueslupa.com , para los siguientes fines:

          1.Suministrar información comercial relacionada con los productos de Empaques Lupa.
          2.Invitar a eventos comerciales a los clientes inscritos en las bases de datos.
          3.Realizar estudios internos de hábitos de consumo.
          4.Para fines comerciales internos, como análisis de datos, auditorías, desarrollo de nuevos productos, mejora de nuestros sitios web, de nuestros servicios, identificación de tendencias de uso y determinación de la efectividad de nuestras campañas promocionales.
          5.Permitirle participar de sorteos, concursos y promociones similares y para administrar estas actividades.

          Derechos del titular de la información
          Derecho a conocer: solicitar a la Compañía en cualquier momento y en forma gratuita, que se le informe cuáles de sus datos personales tiene y cuál es el uso que la misma ha hecho de tales datos.

          Derecho a actualizar: solicitar a Empaques Lupa en cualquier momento y en forma gratuita, que se actualicen sus datos personales, para lo cual deberá proporcionar en forma veraz, oportuna y completa la información que desea se incluya en la base de datos y/o archivo de la Compañía, lo cual comprende la entrega de la documentación soporte que se requiera para tal efecto.

          Derecho a rectificar: si considera que los datos que tiene Empaques Lupa son inexactos o incompletos podrá solicitarle en cualquier momento y en forma gratuita que se corrija tal información, para lo cual deberá identificarse en debida forma, explicar en qué consiste la inexactitud o inconsistencia y suministrar en forma correcta y completa la información que desea se incorpore en la base de datos, lo cual comprende la entrega de la documentación soporte que se requiera para tal efecto.

          Derecho a suprimir: en cualquier momento y sin costo alguno, usted podrá solicitar a Empaques Lupa que elimine los datos que considere necesario, para lo cual deberá identificarse en debida forma y señalar cuál es la información a eliminar, lo cual comprende la entrega de la documentación soporte que se requiera para tal efecto.

          Empaques Lupa es la compañía responsable del tratamiento de la información y aplica el siguiente tratamiento a los datos recopilados.

          Procedimiento para quejas y reclamos
          Para ejercer sus derechos y presentar sugerencias, consultas, reclamos o peticiones, Empaques Lupa ha designado un área, la cual puede contactarse a través de los siguientes canales y en los horarios que a continuación se indican:

          Canal físico: Carrera 31 #9C-70 Cali - Colombia
          WhatsApp (57) 3183953381. Correo electrónico: empaqueslupa@gmail.com 
          Obligaciones del titular de la información
          Suministrar a la Compañía sus datos personales en forma veraz, completa y oportuna; ejercer sus derechos en debida forma; cumplir las medidas de seguridad que la entidad adopte y/o le recomiende adoptar para proteger la confidencialidad de su información; consultar periódicamente la información que en materia de políticas de privacidad tenga la entidad y actualizar su información al menos una vez al año.

          Las presentes políticas entrarán en vigencia a partir del 2 de Julio del 2023 y se mantendrán vigentes hasta tanto no exista una modificación normativa que exija su actualización.
                                                                                                                                                                                                                                                                                                        
  </div>
</template>

<script>

export default {
  
  data() {
    return { 
      
    }
  },
  mounted(){
    
  },
  created() {
     
    },
    computed:{
       
    },
    methods:{
      
    },
    
}
</script>

<style >


</style>
